import { render, staticRenderFns } from "./fwjl.vue?vue&type=template&id=089d7a12&scoped=true"
var script = {}
import style0 from "./fwjl.vue?vue&type=style&index=0&id=089d7a12&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d7a12",
  null
  
)

export default component.exports